import { request } from '../../../lib/request_cms';
//查询租户信息-
export function getTenantInfo(params) {
    return request({
        url: '/local/cms/getTenantInfo',
        method: 'GET',
        params,
    });
}
//查询网站状态
export function getStatus(params) {
    return request({
        url: '/mwebapi/sysconfig/site/siteState/getTenantInfo',
        method: 'get',
        params
    });
}
// 获取seo设置是否完成
export function getSeoStatus() {
    return request({
        url: '/mwebapi/seo/include/website/detection',
        method: 'get',
    });
}
// 设置新手引导步骤
export function guideAddOrUpdateOne(data) {
    return request({
        url: '/pms/tenantRecord/addOrUpdateOne',
        method: 'post',
        data,
    });
}
// 设置控件显示隐藏
export function setWidgetStatus(data) {
    return request({
        url: '/pms/pcpModule/updateStatusByTenantIdAndModuleCode',
        method: 'post',
        data,
        dataType: 'form',
    });
}
// 上线接口
export function updateToOnline() {
    return request({
        url: '/mwebapi/cms/site/siteState/updateToOnline',
        method: 'post',
    });
}
//新的上线接口
export function updatePotalSaasToOnline(logObj, params) {
    return request({
        url: '/mwebapi/cms/site/siteState/updatePotalSaasToOnline',
        method: 'post',
        logObj,
        params,
        logFlag: {
            appName: '网站状态',
            operModule: '网站上线',
            title: '操作了立即上线',
        },
    });
}
//关闭或开启网站移动端
export function updateMobileState(data) {
    return request({
        url: '/mwebapi/sysconfig/site/siteState/updateMobileState',
        method: 'post',
        data,
        // logObj,
        // logFlag: {
        //     appName: '网站状态',
        //     operModule: '变更网站设计状态',
        // },
    });
}
//关闭或开启网站PC端
export function updatePCState(data, logObj) {
    return request({
        url: '/mwebapi/sysconfig/site/siteState/updatePcState',
        method: 'post',
        data,
        logObj,
        logFlag: {
            appName: '网站状态',
            operModule: '变更网站设计状态',
        },
    });
}
//更新网站Pc运营状态 只有目前state字段为6 和7 的时候才让调用底层
export function updateOperateState(data, logObj) {
    return request({
        url: '/mwebapi/sysconfig/site/siteState/updateOperateState',
        method: 'post',
        data,
        logObj,
        logFlag: {
            appName: '网站状态',
            operModule: '变更网站状态',
        },
    });
}
// ===== 旧多语言接口已下线（22/23/24 版统一走下方 languageForward/batchGet、batchUpdate），先注释保留，确认稳定后再删除 =====
// //多语言 - 选择的语言
// export function getLanguage() {
//     return request({
//         url: '/mwebapi/sysconfig/getForward/api/sysconfig/site/multilingual/get',
//         method: 'get',
//     });
// }
// //多语言 - 设置状态
// export function updateLanguageState(data, params, logObj) {
//     return request({
//         url: '/mwebapi/sysconfig/site/multilingual/updateMultilingualState',
//         method: 'post',
//         data,
//         params,
//         logObj,
//         logFlag: {
//             appName: '网站状态',
//             operModule: '变更多语言状态',
//         },
//     });
// }
// //多语言 - 更新选择语言
// export function updateLanguage(data) {
//     return request({
//         url: '/mwebapi/sysconfig/getForward/api/sysconfig/site/multilingual/update',
//         method: 'post',
//         data,
//     });
// }
//多语言 - 已购买语言
export function getlanguageAndDomain(params) {
    return request({
        url: '/mwebapi/sysconfig/getForward/api/sysconfig/site/multilingual/getlanguageAndDomain',
        method: 'get',
        params,
    });
}
//多语言 - 已购买语言
export function getlanguageAndDomain2(params) {
    return request({
        url: '/api/sysconfig/site/languageForward/getlanguageAndDomain',
        method: 'get',
        params,
    });
}
//多语言跳转 - 批量查询。params: { tenantIds: '311227,311228' }，返回 { [tenantId]: 配置 }，配置.state 即该站点的智能跳转开关（0关/1开）
//旧的 multilingual/get、updateMultilingualState、update 已下线，22/23/24 版统一使用这组接口
export function batchGetLanguageForward(params) {
    return request({
        url: '/mwebapi/sysconfig/getForward/api/sysconfig/site/languageForward/batchGet',
        method: 'get',
        params,
    });
}
// batchGet/batchUpdate 的响应：外层 { status, data }，内层 data 可能再包一层 { status, data, msg }，取出真正的业务数据
export function unwrapLanguageForward(res) {
    const d = res && res.data;
    return d && typeof d === 'object' && !Array.isArray(d) && 'status' in d ? d.data : d;
}
//多语言跳转 - 批量更新。data 是 batchGet 返回的配置数组（每项含 state：该站点智能跳转开关），改完再整体回传
export function batchUpdateLanguageForward(data, logObj) {
    return request({
        url: '/mwebapi/sysconfig/getForward/api/sysconfig/site/languageForward/batchUpdate',
        method: 'post',
        data,
        logObj,
        logFlag: {
            appName: '网站状态',
            operModule: '变更多语言状态',
        },
    });
}
//全局置灰状态   获取开关状态
export function getAshState(params) {
    return request({
        url: '/mwebapi/sysconfig/globalAsh/multilingual/getAshState',
        method: 'get',
        params,
    });
}
//全局置灰状态   更新全局置灰开关
export function updateAshState(params, logObj) {
    return request({
        url: '/mwebapi/sysconfig/globalAsh/multilingual/updateAshState',
        method: 'post',
        params,
        logObj,
        logFlag: {
            appName: '网站状态',
            operModule: '变更网站主题',
        },
    });
}


export function get2024Status(params) {
    return request({
        url: '/mwebapi/sysconfig/site/siteState/getTenantInfos',
        method: 'get',
        params,
    });
}

//全局置灰状态   获取开关状态
export function getAshStateList(params) {
    return request({
        url: '/mwebapi/sysconfig/globalAsh/multilingual/getAshStateList',
        method: 'get',
        params,
    })
}
// 获取网站状态
export function getDesignState() {
    return request({
        url: '{#npgw}/cmstenant/tenant/design/ext/select',
        method: 'get',
    });
}

// 修改网站状态
export function setDesignState(data, params) {
    return request({
        url: '{#npgw}/cmstenant/tenant/design/ext/saveOrUpdate',
        method: 'post',
        data,
        params,
        // dataType: 'json'
    });
}
//更新网站Pc运营状态 只有目前state字段为6 和7 的时候才让调用底层
export function updateOperateState2024(data, params, logObj) {
    return request({
        url: '/mwebapi/sysconfig/site/siteState/updateOperateState',
        method: 'post',
        data,
        params,
        logObj,
        logFlag: {
            appName: '网站状态',
            operModule: '变更网站状态',
        },
    });
}
//网站上线-预上线查询接口
export function preOnlineInfo(params) {
    return request({
        url: '/mwebapi/cms/site/siteState/preOnlineInfo',
        method: 'get',
        params,
    });
}
//预上线接口
export function updatePrePotalSaasToOnline(logObj, params) {
    return request({
        url: '/mwebapi/cms/site/siteState/updatePrePotalSaasToOnline',
        method: 'post',
        logObj,
        params,
        logFlag: {
            appName: '网站状态',
            operModule: '网站预上线',
            title: '操作了预上线',
        },
    });
}